import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *toList(_this__u8e3s4, destination, $completion) {
  destination = destination === VOID ? ArrayList().p2() : destination;
  return yield* toCollection(_this__u8e3s4, destination, $completion);
}
function *toCollection(_this__u8e3s4, destination, $completion) {
  var tmp = toCollection$slambda_0(destination);
  yield* _this__u8e3s4.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
  return destination;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.r1h_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.r1h_1(value, $completion);
      }
      i5() {
        return this.r1h_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var toCollection$slambdaClass;
function toCollection$slambda() {
  if (toCollection$slambdaClass === VOID) {
    class $ {
      constructor($destination) {
        this.s1h_1 = $destination;
      }
      *e1g(value, $completion) {
        this.s1h_1.i2(value);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.e1g(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    toCollection$slambdaClass = $;
  }
  return toCollection$slambdaClass;
}
function toCollection$slambda_0($destination) {
  var i = new (toCollection$slambda())($destination);
  var l = (value, $completion) => i.e1g(value, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  toList as toList3oc4f57w5sjau,
};
//endregion

//# sourceMappingURL=Collection.mjs.map
